import React, { useContext } from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import ThemeContext from 'src/libraries/contexts/Theme'

const ContentViewport = ({ children }) => {
   const theme = useContext(ThemeContext)

   return (
      <View
         position="absolute"
         top="0px[a-b] 30px[c-f]"
         left="0px[a-d] 270px[c] 300px[d-f]"
         right="0px[a-b] 12px[c-f]"
         bottom="0px[a-b] 30px[c-f]"
         borderRadius="3px"
         borderRight="30px solid rgba(0, 0, 0, 0.1)[d-f]"
         backgroundColor={theme.protoSettingsViewportBackgroundColor}>
         {children}
      </View>
   )
}

ContentViewport.propTypes = {
   children: PropTypes.node.isRequired
}

export default ContentViewport
